var e=function(e,n){if(!n)return"";var r=n.type,a=n.name;return{online:"contact_lenses"!==e&&a?"Saved prescription":"Filled in",email:"Send later",upload:"Uploaded"}[r]||""};export{e as getPrescriptionType};
